<template>
  <div>
    <div id="app-debugger">
      Debugger
      {{ currentUser }}
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {parse, stringify} from 'flatted';

export default {
  computed: {
    currentUser() {
      return parse(stringify(this.$context.$currentUser));
    }
  }
}
</script>

<style>
#app-debugger {
  z-index: 999999999999;
  position: fixed;
  background: #00000063;
  width: auto;
  height: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
}
</style>